import { SafeSpace } from '../types';
import transactInSpace from './transactInSpace';
import * as Y from 'yjs';

export default function updateTaskStatusDefinitions(space: SafeSpace, id: string, name: string) {
    transactInSpace(space, () => {
        const taskStatuses = space.map.get('taskStatuses') as Y.Array<Y.Map<unknown>> | undefined;

        if (!taskStatuses) {
            return;
        }

        for (let i = 0; i < taskStatuses.length; i++) {
            const statusMap = taskStatuses.get(i);
            const subStatusArray = statusMap.get('subStatus') as Y.Array<Y.Map<unknown>> | undefined;

            if (subStatusArray) {
                for (let j = 0; j < subStatusArray.length; j++) {
                    const subStatus = subStatusArray.get(j);
                    if (subStatus.get('id') === id) {
                        subStatus.set('status', name);
                        subStatus.set('isDefault', false);
                        return;
                    }
                }
            }
        }
    });
}
